import React, { FunctionComponent } from 'react'
import styled from 'styled-components'
import { AutoImage } from './auto-image'

const Outer = styled.div`
  position: relative;
`

const Inner = styled.div`
  display: flex;
  gap: 0.5rem;
`

const Item = styled.div`
  flex: 1 1 auto;
  img {
    width: 100%;
  }
`

const Decoration = styled.div`
  position: absolute;
  img {
    display: block;
    height: var(--size, 4rem);
    width: auto;
  }
`

const LeftTopDecoration = styled(Decoration)`
  top: -1.5rem;
  left: 0;
`

const LeftBottomDecoration = styled(Decoration)`
  bottom: -1.5rem;
  left: 0;
`
const RightTopDecoration = styled(Decoration)`
  top: -1.5rem;
  right: 0;
`
const RightBottomDecoration = styled(Decoration)`
  bottom: -1.5rem;
  right: 0;
`

type DecoratedFrameProps = {
  leftTop?: string,
  leftBottom?: string,
  rightTop?: string
  rightBottom?: string
  size?: string
}
export const DecoratedFrame: FunctionComponent<DecoratedFrameProps> = ({children, leftTop, leftBottom, rightTop, rightBottom, size}) => {
  return <Outer style={{'--size': size ?? '4rem'}}>
    <Inner>
      {
        Array.isArray(children) ? 
          children.map((child, i) => <Item key={i}>{child}</Item>) :
          <Item>{children}</Item>
      }
    </Inner>
    {
      leftTop &&
      <LeftTopDecoration>
        <AutoImage src={leftTop} />
      </LeftTopDecoration>
    }
    {
      leftBottom &&
      <LeftBottomDecoration>
        <AutoImage src={leftBottom} />
      </LeftBottomDecoration>
    }
    {
      rightTop &&
      <RightTopDecoration>
        <AutoImage src={rightTop} />
      </RightTopDecoration>
    }
    {
      rightBottom &&
      <RightBottomDecoration>
        <AutoImage src={rightBottom} />
      </RightBottomDecoration>
    }
  </Outer>
}